module.exports = __webpack_public_path__ + "img/cut_sc3.ce695ba4.jpg";